<template>
    <div class="import">
        <el-upload action="" :headers="headers" ref="uploadMutiple" :multiple="multiple" :show-file-list="false" :http-request="upload">
            <el-tooltip v-if="show_tooltip" class="item" :effect="effect" :content="tooltip_content"
                :placement="placement">
                <el-button :type="type" :size="size">
                    <slot name="name"></slot>
                </el-button>
            </el-tooltip>
            <el-button v-else :type="type" :size="size">
                <slot name="name"></slot>
            </el-button>
        </el-upload>
    </div>
</template>

<script>
export default {
    name: 'Import',
    props: {
        type: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: 'mini'
        },
        show_tooltip: {
            type: Boolean,
            default: false
        },
        effect: {
            type: String,
            default: 'dark'
        },
        tooltip_content: {
            type: String,
        },
        placement: {
            type: String,
            default: 'top'
        },
        data: {
            required: false
        },
        extraData: {
            required: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            headers: { Authorization: localStorage.token },
        }
    },
    methods: {
        upload(param) {
            this.$message.success('导入时间可能过长,不必停留在此页面。系统已在后台处理导入!');
            setTimeout(() => {
                const formData = new FormData()
                formData.append('file', param.file)
                formData.append('extraParam', this.data)
                formData.append('extraData', this.extraData)
                formData.append('loadingClose', true)
                this.$axios.post('api/api3_common_import', formData).then(({ data }) => {
                    this.$emit('imported',data)
                    // if (data.code !== 200) {
                    //     this.$message.error(data.msg)
                    // } else {
                    //     this.$message.success(data)
                    // }
                }).catch(response => {
                    console.log(response)
                })
            }, 500)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/Import.vue